module.exports = __webpack_public_path__ + "assets/social-instagram.70e129a2.svg";